import { Routes } from '@angular/router';

export const content: Routes = [

  {
    path: 'dashboard',
    loadChildren: () => import('../../features/dashboard/dashboard.module').then(d => d.DashboardModule),
    data: { title: 'Dashboard', breadcrumb: 'Dashboard'}
  },
  {
    path: 'gnr', 
    loadChildren: () => import('../../features/gnr/gnr.module').then(m => m.GnrModule), 
    data: { title: 'GNR', breadcrumb: 'BonoGas'}
  }

];
